<div class="admin-import-module__preflight-result">
  <div class="admin-import-module__preflight-tiles">
    <mat-card appearance="outlined" class="admin-import-module__preflight-tile">
      <mat-card-content class="admin-import-module__preflight-tile-content">
        <span class="admin-import-module__preflight-tile-label">{{ 'TRANS__IMPORT__PREFLIGHT_TILE_CHECKED' | translate }}</span>
        <span class="admin-import-module__preflight-tile-value">{{ coverage.checked | number }}</span>
        <span class="admin-import-module__preflight-tile-label admin-import-module__preflight-coverage">
          @if (coverage.all) {
            {{ 'TRANS__IMPORT__PREFLIGHT_TILE_CHECKED_OF' | translate: {total: coverage.total} }}
          } @else if (coverage.total !== null) {
            {{ 'TRANS__IMPORT__PREFLIGHT_TILE_CHECKED_RANGE_OF' | translate:
               {first: coverage.firstRow, last: coverage.lastRow, total: coverage.total} }}
          } @else {
            {{ 'TRANS__IMPORT__PREFLIGHT_TILE_CHECKED_RANGE' | translate:
               {first: coverage.firstRow, last: coverage.lastRow} }}
          }
        </span>
      </mat-card-content>
    </mat-card>
    <mat-card appearance="outlined" class="admin-import-module__preflight-tile">
      <mat-card-content class="admin-import-module__preflight-tile-content">
        <span class="admin-import-module__preflight-tile-label">{{ 'TRANS__IMPORT__PREFLIGHT_TILE_CLEAN' | translate }}</span>
        <span class="admin-import-module__preflight-tile-value">
          {{ coverage.checked - preflightResult.summary.rows_with_warnings | number }}
        </span>
        <span class="admin-import-module__preflight-tile-label">{{ 'TRANS__IMPORT__PREFLIGHT_TILE_ROWS' | translate }}</span>
      </mat-card-content>
    </mat-card>
    <mat-card
      appearance="outlined"
      class="admin-import-module__preflight-tile"
      [class.admin-import-module__preflight-tile--warn]="preflightResult.summary.rows_with_warnings > 0"
    >
      <mat-card-content class="admin-import-module__preflight-tile-content">
        <span class="admin-import-module__preflight-tile-label">{{ 'TRANS__IMPORT__PREFLIGHT_TILE_WARNED' | translate }}</span>
        <span class="admin-import-module__preflight-tile-value">{{ preflightResult.summary.rows_with_warnings | number }}</span>
        <span class="admin-import-module__preflight-tile-label">
          @if (view.groups.length === 1) {
            {{ 'TRANS__IMPORT__PREFLIGHT_TILE_WARNED_TYPES_ONE' | translate }}
          } @else {
            {{ 'TRANS__IMPORT__PREFLIGHT_TILE_WARNED_TYPES' | translate: {types: view.groups.length} }}
          }
        </span>
      </mat-card-content>
    </mat-card>
    <mat-card
      appearance="outlined"
      class="admin-import-module__preflight-tile"
      [class.admin-import-module__preflight-tile--error]="view.errors.length > 0"
    >
      <mat-card-content class="admin-import-module__preflight-tile-content">
        <span class="admin-import-module__preflight-tile-label">{{ 'TRANS__IMPORT__PREFLIGHT_TILE_BLOCKING' | translate }}</span>
        <span class="admin-import-module__preflight-tile-value">
          {{ view.errors.length | number }}
          @if (!view.errors.length) {
            <mat-icon class="admin-import-module__preflight-tile-ok" aria-hidden="true">check</mat-icon>
          }
        </span>
        <span class="admin-import-module__preflight-tile-label">{{ 'TRANS__IMPORT__PREFLIGHT_TILE_ERRORS' | translate }}</span>
      </mat-card-content>
    </mat-card>
  </div>

  @if (view.errors.length) {
    <div class="admin-import-module__warn admin-import-module__preflight-errors">
      <p>{{ 'TRANS__IMPORT__PREFLIGHT_ERRORS' | translate }}:</p>
      <ul class="admin-import-module__preflight-error-list">
        @for (error of view.errors; track $index) {
          <li>{{ error }}</li>
        }
      </ul>
    </div>
  }

  @if (view.notRefusingErrors.length) {
    <div class="admin-import-module__preflight-note">
      <mat-icon aria-hidden="true">info</mat-icon>
      <div>
        <p>{{ 'TRANS__IMPORT__PREFLIGHT_ERRORS_NOT_BLOCKING' | translate }}:</p>
        <ul class="admin-import-module__preflight-error-list">
          @for (error of view.notRefusingErrors; track $index) {
            <li>{{ error }}</li>
          }
        </ul>
      </div>
    </div>
  }

  @if (preflightResult.summary.created_at_invalid || preflightResult.summary.created_by_unresolved) {
    <p class="admin-import-module__warn">
      {{ 'TRANS__IMPORT__PREFLIGHT_SUMMARY_CREATED_REVISION' | translate:
         {invalid: preflightResult.summary.created_at_invalid ?? 0,
          unresolved: preflightResult.summary.created_by_unresolved ?? 0} }}
    </p>
  }

  @if (mediaBlocksRun) {
    <p class="admin-import-module__warn bold">
      {{ 'TRANS__IMPORT__PREFLIGHT_MEDIA_BLOCKS' | translate:
         {unmatched: preflightResult.summary.media_unmatched,
          ambiguous: preflightResult.summary.media_ambiguous} }}
    </p>
  }

  @if (preflightResult.summary.media_already_linked) {
    <p class="admin-import-module__warn admin-import-module__preflight-media-already-linked">
      {{ 'TRANS__IMPORT__PREFLIGHT_SUMMARY_MEDIA_ALREADY_LINKED' | translate:
         {count: preflightResult.summary.media_already_linked} }}
    </p>
  }

  @if (preflightResult.summary.media_partly_linked) {
    <p class="admin-import-module__warn admin-import-module__preflight-media-partly-linked">
      {{ 'TRANS__IMPORT__PREFLIGHT_SUMMARY_MEDIA_PARTLY_LINKED' | translate:
         {count: preflightResult.summary.media_partly_linked} }}
    </p>
  }

  @if (preflightResult.summary.media_shared_file) {
    <p class="admin-import-module__warn admin-import-module__preflight-media-shared-file">
      {{ 'TRANS__IMPORT__PREFLIGHT_SUMMARY_MEDIA_SHARED_FILE' | translate:
         {count: preflightResult.summary.media_shared_file} }}
    </p>
  }

  @if (preflightResult.summary.media_shared_rows) {
    <p class="admin-import-module__warn admin-import-module__preflight-media-shared-rows">
      {{ 'TRANS__IMPORT__PREFLIGHT_SUMMARY_MEDIA_SHARED_ROWS' | translate:
         {count: preflightResult.summary.media_shared_rows} }}
    </p>
  }

  @if (view.mediaUnchecked) {
    <p class="admin-import-module__hint admin-import-module__preflight-media-unchecked">
      {{ 'TRANS__IMPORT__PREFLIGHT_MEDIA_NOT_CHECKED' | translate }}
    </p>
  }

  @if (preflightResult.media_overview; as overview) {
    <section
      class="admin-import-module__preflight-block admin-import-module__preflight-media-overview"
      aria-labelledby="import-preflight-media-overview"
    >
      <div class="admin-import-module__preflight-block-head">
        <h5 id="import-preflight-media-overview">{{ 'TRANS__IMPORT__PREFLIGHT_MEDIA_OVERVIEW' | translate }}</h5>
        <button
          mat-stroked-button
          color="primary"
          type="button"
          class="admin-import-module__preflight-media-download"
          [disabled]="!overview.files_without_row_total"
          (click)="downloadFilesWithoutRow(overview)"
        >
          <mat-icon aria-hidden="true">download</mat-icon>
          <span class="bold uppercase">{{ 'TRANS__IMPORT__PREFLIGHT_MEDIA_OVERVIEW_DOWNLOAD' | translate }}</span>
        </button>
      </div>
      <div class="admin-import-module__preflight-media-overview-body">
        <p class="admin-import-module__preflight-media-overview-files">
          {{ 'TRANS__IMPORT__PREFLIGHT_MEDIA_OVERVIEW_FILES' | translate:
             {files: overview.files_in_folder, matched: overview.files_matched,
              withoutRow: overview.files_without_row_total} }}
        </p>
        <p class="admin-import-module__preflight-media-overview-rows">
          {{ 'TRANS__IMPORT__PREFLIGHT_MEDIA_OVERVIEW_ROWS' | translate:
             {withFiles: overview.rows_with_files, several: overview.rows_with_several_files,
              withoutFiles: overview.rows_without_files, blank: overview.rows_blank} }}
        </p>
        @if (overview.files_on_several_rows.length) {
          <details class="admin-import-module__preflight-media-several">
            <summary>
              {{ 'TRANS__IMPORT__PREFLIGHT_MEDIA_OVERVIEW_SEVERAL_ROWS' | translate:
                 {count: overview.files_on_several_rows_total} }}
            </summary>
            <ul>
              @for (entry of overview.files_on_several_rows; track $index) {
                <li>
                  {{ 'TRANS__IMPORT__PREFLIGHT_MEDIA_OVERVIEW_FILE_ROWS' | translate:
                     {file: entry.file_name, rows: entry.rows.join(', ')} }}
                  @if (entry.rows_total > entry.rows.length) {
                    {{ 'TRANS__IMPORT__PREFLIGHT_MEDIA_OVERVIEW_FILE_ROWS_TOTAL' | translate: {total: entry.rows_total} }}
                  }
                </li>
              }
              @if (droppedCount(overview.files_on_several_rows_total, overview.files_on_several_rows.length); as more) {
                <li class="admin-import-module__preflight-media-several-more">
                  {{ 'TRANS__IMPORT__RUN_AND_N_MORE' | translate: {count: more} }}
                </li>
              }
            </ul>
          </details>
        }
      </div>
    </section>
  } @else if (mediaFolderMissing) {
    <p class="admin-import-module__hint admin-import-module__preflight-media-no-folder">
      {{ 'TRANS__IMPORT__PREFLIGHT_MEDIA_OVERVIEW_NO_FOLDER' | translate }}
    </p>
  }

  @if (preflightResult.id_numbering; as numbering) {
    <p class="admin-import-module__hint"
       [class.admin-import-module__warn]="preflightResult.summary.id_numbers_short"
       [class.bold]="preflightResult.summary.id_numbers_short">
      {{ 'TRANS__IMPORT__PREFLIGHT_ID_NUMBERING' | translate:
         {template: numbering.template, digits: numbering.digits,
          left: numbering.numbers_left} }}
      @if (preflightResult.summary.id_numbers_short) {
        {{ 'TRANS__IMPORT__PREFLIGHT_ID_NUMBERING_SHORT' | translate: {rows: numbering.rows} }}
      }
      {{ 'TRANS__IMPORT__PREFLIGHT_ID_NUMBERING_DUPLICATES' | translate }}
    </p>
  }

  @if (view.alwaysFiringEventGroups.length) {
    <p class="admin-import-module__preflight-note">
      <mat-icon aria-hidden="true">info</mat-icon>
      <span>
        {{ 'TRANS__IMPORT__PREFLIGHT_EVENT_ALWAYS_FIRES' | translate }}
        @for (g of view.alwaysFiringEventGroups; track g.key) {
          @if (g.title; as title) {
            <span class="admin-import-module__preflight-event">
              {{ title }}
            </span>
          }
        }
      </span>
    </p>
  }

  @if (view.groups.length) {
    <section class="admin-import-module__preflight-block" aria-labelledby="import-preflight-warnings">
      <div class="admin-import-module__preflight-block-head">
        <h5 id="import-preflight-warnings">{{ 'TRANS__IMPORT__PREFLIGHT_WARNINGS' | translate }}</h5>
        <span class="admin-import-module__hint">{{ 'TRANS__IMPORT__PREFLIGHT_WARNINGS_HINT' | translate }}</span>
      </div>
      <ul class="admin-import-module__preflight-groups">
        @for (group of view.groups; track group.typeKey) {
          <li
            class="admin-import-module__preflight-group"
            [class.admin-import-module__preflight-group--selected]="group === selectedGroup"
          >
            <button
              type="button"
              class="admin-import-module__preflight-group-select"
              [attr.aria-pressed]="group === selectedGroup"
              (click)="selectGroup(group)"
            >
              <mat-icon class="admin-import-module__preflight-warn-icon" aria-hidden="true">warning_amber</mat-icon>
              <span class="admin-import-module__preflight-group-text">
                <ng-container
                  *ngTemplateOutlet="warningText; context: {$implicit: group.warning, grouped: !group.withValue}"
                ></ng-container>
              </span>
              <span class="admin-import-module__preflight-group-count">
                <ng-container *ngTemplateOutlet="rowCount; context: {$implicit: group.rows.length}"></ng-container>
              </span>
            </button>
            @if (group.fix?.kind === 'view') {
              <button
                mat-button
                color="primary"
                type="button"
                class="admin-import-module__preflight-fix"
                (click)="openFix(group)"
              >
                {{ group.fix.labelKey | translate: {value: group.warning.value} }}
                <mat-icon iconPositionEnd aria-hidden="true">arrow_forward</mat-icon>
              </button>
            } @else if (group.fix) {
              <span class="admin-import-module__hint admin-import-module__preflight-fix">
                {{ group.fix.labelKey | translate }}
              </span>
            }
          </li>
        }
      </ul>
    </section>

    <section class="admin-import-module__preflight-block" aria-labelledby="import-preflight-warning-rows">
      <div class="admin-import-module__preflight-block-head">
        <h5 id="import-preflight-warning-rows">{{ 'TRANS__IMPORT__PREFLIGHT_WARNING_ROWS' | translate }}</h5>
        <span class="admin-import-module__preflight-badge">{{ listedRows.length | number }}</span>
        <span class="admin-import-module__hint">
          {{ 'TRANS__IMPORT__PREFLIGHT_WARNING_ROWS_SHOWN' | translate:
             {shown: shownRows < listedRows.length ? shownRows : listedRows.length} }}
        </span>
        @if (selectedGroup) {
          <button mat-button color="primary" type="button" class="admin-import-module__preflight-clear" (click)="clearGroup()">
            <mat-icon aria-hidden="true">close</mat-icon>
            {{ 'TRANS__IMPORT__PREFLIGHT_CLEAR_FILTER' | translate }}
          </button>
        }
      </div>
      <ul class="admin-import-module__preflight-rows admin-import-module__preflight-rows--warnings">
        @for (rowView of listedRows.slice(0, shownRows); track rowView.row.row) {
          @let open = openRows.has(rowView.row.row);
          <li>
            <div class="admin-import-module__preflight-row">
              <ng-container *ngTemplateOutlet="rowHead; context: {$implicit: rowView}"></ng-container>
              <button
                mat-button
                color="primary"
                type="button"
                class="admin-import-module__preflight-row-toggle"
                [attr.aria-expanded]="open"
                (click)="toggleRowValues(rowView)"
              >
                {{ (open ? 'TRANS__IMPORT__PREFLIGHT_ROW_VALUES_HIDE' : 'TRANS__IMPORT__PREFLIGHT_ROW_VALUES_SHOW') | translate }}
                <mat-icon iconPositionEnd aria-hidden="true">{{ open ? 'expand_less' : 'expand_more' }}</mat-icon>
              </button>
            </div>
            @if (open) {
              <ng-container *ngTemplateOutlet="rowValues; context: {$implicit: rowView}"></ng-container>
            }
          </li>
        }
      </ul>
      @if (shownRows < listedRows.length) {
        <div class="admin-import-module__preflight-more">
          @if (listedRows.length - shownRows > rowsStep) {
            <button mat-stroked-button color="primary" type="button" class="admin-import-module__preflight-show-more" (click)="showMoreRows()">
              <span class="bold uppercase">{{ 'TRANS__IMPORT__PREFLIGHT_SHOW_MORE' | translate: {count: rowsStep} }}</span>
            </button>
          }
          <button mat-button color="primary" type="button" class="admin-import-module__preflight-show-all" (click)="showAllRows()">
            <span class="bold uppercase">{{ 'TRANS__IMPORT__PREFLIGHT_SHOW_ALL' | translate: {count: listedRows.length} }}</span>
          </button>
        </div>
      }
    </section>
  } @else {
    <p class="admin-import-module__hint">
      {{ 'TRANS__IMPORT__PREFLIGHT_NO_WARNINGS' | translate }}
    </p>
  }

  @if (view.rows.length) {
    <section class="admin-import-module__preflight-block">
      <button
        type="button"
        class="admin-import-module__preflight-all-toggle"
        [attr.aria-expanded]="allRowsOpen"
        (click)="toggleAllRows()"
      >
        <mat-icon aria-hidden="true">{{ allRowsOpen ? 'expand_more' : 'chevron_right' }}</mat-icon>
        <span class="admin-import-module__preflight-all-text">
          <span class="bold">
            {{ 'TRANS__IMPORT__PREFLIGHT_ALL_ROWS' | translate }}
            <span class="admin-import-module__preflight-all-count">({{ view.rows.length | number }})</span>
          </span>
          <span class="admin-import-module__hint">{{ 'TRANS__IMPORT__PREFLIGHT_ALL_ROWS_HINT' | translate: {count: rowsStep} }}</span>
        </span>
      </button>
      @if (allRowsOpen) {
        <ul class="admin-import-module__preflight-rows admin-import-module__preflight-rows--all">
          @for (rowView of view.rows.slice(0, allRowsShown); track rowView.row.row) {
            <li>
              <div class="admin-import-module__preflight-row">
                <ng-container *ngTemplateOutlet="rowHead; context: {$implicit: rowView}"></ng-container>
              </div>
              <ng-container *ngTemplateOutlet="rowValues; context: {$implicit: rowView}"></ng-container>
            </li>
          }
        </ul>
        @if (allRowsShown < view.rows.length) {
          <div class="admin-import-module__preflight-more">
            <button mat-stroked-button color="primary" type="button" class="admin-import-module__preflight-show-more" (click)="showMoreOfAllRows()">
              <span class="bold uppercase">{{ 'TRANS__IMPORT__PREFLIGHT_SHOW_MORE' | translate: {count: rowsStep} }}</span>
            </button>
          </div>
        }
      }
    </section>
  }
</div>

<!-- A row's number, its identification number and first value, then its
     warnings and the events it creates. -->
<ng-template #rowHead let-rowView>
  @let row = rowView.row;
  <span class="admin-import-module__preflight-row-number">{{ row.row }}</span>
  <div class="admin-import-module__preflight-row-body">
    <span class="admin-import-module__preflight-row-title">
      @if (row.id_number && row.id_number.status === 'ok') {
        <span class="admin-import-module__preflight-row-id">{{ row.id_number.value }}</span>
      }
      @if (rowView.composed[0]; as first) {
        <span class="admin-import-module__preflight-row-first">{{ first.text }}</span>
      }
    </span>
    @for (w of rowView.warnings; track $index) {
      <span class="admin-import-module__warn admin-import-module__preflight-row-warning">
        <mat-icon class="admin-import-module__preflight-warn-icon" aria-hidden="true">warning_amber</mat-icon>
        <span><ng-container *ngTemplateOutlet="warningText; context: {$implicit: w, grouped: false}"></ng-container></span>
      </span>
    }
    @for (e of rowView.events; track e.key) {
      @if (e.title; as title) {
        <span class="admin-import-module__preflight-event">
          {{ 'TRANS__IMPORT__PREFLIGHT_EVENT_ROW' | translate: {label: title} }}
        </span>
      }
    }
  </div>
</ng-template>

<!-- A row's field values as the run saves them; a value a warning names
     stands out. -->
<ng-template #rowValues let-rowView>
  @let row = rowView.row;
  <span class="admin-import-module__preflight-composed">
    @if (row.id_number && row.id_number.status === 'ok') {
      <span class="admin-import-module__preflight-field">
        <span class="admin-import-module__preflight-field-label">
          {{ 'TRANS__IMPORT__TARGET__IDENTIFICATION_NUMBER' | translate }}
        </span>
        <span class="admin-import-module__preflight-field-value">{{ row.id_number.value }}</span>
      </span>
    }
    @for (part of createdRevisionParts(row); track part[0]) {
      @if (part[1].status === 'ok') {
        <span class="admin-import-module__preflight-field">
          <span class="admin-import-module__preflight-field-label">
            {{ createdRevisionKindLabel(part[0]) }}
          </span>
          <span class="admin-import-module__preflight-field-value">{{ part[1].value }}</span>
        </span>
      }
    }
    @if (row.media; as media) {
      @if (media.media.length || (mediaPatternMode && media.key)) {
        <span class="admin-import-module__preflight-field admin-import-module__preflight-field--media">
          <span class="admin-import-module__preflight-field-label">{{ 'TRANS__IMPORT__MEDIA_SECTION' | translate }}</span>
          <span class="admin-import-module__preflight-field-value">
            @for (file of media.media; track file.media_id) {
              <span class="admin-import-module__preflight-media-file">{{ file.file_name }}@if (file.linked) {
                ({{ 'TRANS__IMPORT__PREFLIGHT_MEDIA_LINKED_MARK' | translate }})}</span>@if (!$last) {, }
            }
            @if (mediaPatternMode && media.key) {
              <span class="admin-import-module__preflight-media-key">
                {{ 'TRANS__IMPORT__PREFLIGHT_MEDIA_KEY' | translate: {key: media.key} }}
              </span>
            }
          </span>
        </span>
      }
    }
    @for (c of rowView.mediaComposed; track $index) {
      <ng-container *ngTemplateOutlet="composedValue; context: {$implicit: c}"></ng-container>
    }
    @for (c of rowView.composed; track $index) {
      <ng-container *ngTemplateOutlet="composedValue; context: {$implicit: c}"></ng-container>
    }
  </span>
</ng-template>

<!-- One of a row's values under its label; a value a warning names stands
     out. A party name the run creates or takes one of several for carries
     a muted note under it, which is information and not a warning. -->
<ng-template #composedValue let-c>
  @if (c.infoKey) {
    <span class="admin-import-module__preflight-field-noted">
      <ng-container *ngTemplateOutlet="composedField; context: {$implicit: c}"></ng-container>
      <span class="admin-import-module__hint admin-import-module__preflight-field-note">
        {{ c.infoKey | translate: {value: c.entry.value} }}
      </span>
    </span>
  } @else {
    <ng-container *ngTemplateOutlet="composedField; context: {$implicit: c}"></ng-container>
  }
</ng-template>

<ng-template #composedField let-c>
  <span class="admin-import-module__preflight-field"
        [class.admin-import-module__preflight-field--warned]="c.warned"
        [title]="c.title">
    <span class="admin-import-module__preflight-field-label">{{ c.label }}</span>
    <span class="admin-import-module__preflight-field-value">{{ c.text }}</span>
  </span>
</ng-template>

<!-- "1 rad" / "N rader". -->
<ng-template #rowCount let-count>
  @if (count === 1) {
    {{ 'TRANS__IMPORT__PREFLIGHT_ROW_COUNT_ONE' | translate }}
  } @else {
    {{ 'TRANS__IMPORT__PREFLIGHT_ROW_COUNT' | translate: {count: count} }}
  }
</ng-template>

<!-- A warning's text; `grouped` leaves out a value that is the row's own
     (see WarningGroup), and a media warning's files other rows name too,
     each by name unless the name is the row's own value.
     A field warning's reasons are translation keys, or a keyword with no
     key, which the pipe echoes. -->
<ng-template #warningText let-w let-grouped="grouped">
  @switch (w.kind) {
    @case ('field') {
      @if (grouped) {
        {{ w.label }}: <ng-container *ngTemplateOutlet="fieldReasons; context: {$implicit: w.reasons}"></ng-container>
      } @else {
        {{ w.label }}: "{{ w.value }}" — <ng-container *ngTemplateOutlet="fieldReasons; context: {$implicit: w.reasons}"></ng-container>
      }
    }
    @case ('concept') {
      {{ 'TRANS__IMPORT__PREFLIGHT_CONCEPT_WARN' | translate: {label: w.label, value: w.value} }}
    }
    @case ('place') {
      @switch (w.reason) {
        @case ('unmatched') {
          {{ 'TRANS__IMPORT__PREFLIGHT_PLACE_UNMATCHED_WARN' | translate: {label: w.label, value: w.value} }}
        }
        @case ('ambiguous') {
          {{ 'TRANS__IMPORT__PREFLIGHT_PLACE_AMBIGUOUS_WARN' | translate: {label: w.label, value: w.value} }}
        }
        @case ('invalid') {
          {{ 'TRANS__IMPORT__PREFLIGHT_PLACE_INVALID_WARN' | translate: {label: w.label, value: w.value} }}
        }
      }
    }
    @case ('party') {
      {{ 'TRANS__IMPORT__PREFLIGHT_PARTY_UNMATCHED_WARN' | translate: {label: w.label, value: w.value} }}
    }
    @case ('location') {
      @switch (w.reason) {
        @case ('unmatched') {
          {{ 'TRANS__IMPORT__PREFLIGHT_LOCATION_UNMATCHED_WARN' | translate: {label: w.label, value: w.value} }}
        }
        @case ('ambiguous') {
          {{ 'TRANS__IMPORT__PREFLIGHT_LOCATION_AMBIGUOUS_WARN' | translate: {label: w.label, value: w.value} }}
        }
      }
    }
    @case ('kulturnav') {
      {{ 'TRANS__IMPORT__PREFLIGHT_KULTURNAV_INVALID' | translate: {label: w.label, value: w.value} }}
    }
    @case ('card') {
      @switch (w.reason) {
        @case ('required_blank') {
          {{ 'TRANS__IMPORT__PREFLIGHT_CARD_REQUIRED_BLANK' | translate: {label: w.label} }}
        }
      }
    }
    @case ('media') {
      @switch (w.reason) {
        @case ('unmatched') { {{ 'TRANS__IMPORT__PREFLIGHT_MEDIA_UNMATCHED' | translate }} }
        @case ('ambiguous') { {{ 'TRANS__IMPORT__PREFLIGHT_MEDIA_AMBIGUOUS' | translate }} }
        @case ('already_linked') { {{ 'TRANS__IMPORT__PREFLIGHT_MEDIA_ALREADY_LINKED' | translate }} }
        @case ('partly_linked') { {{ 'TRANS__IMPORT__PREFLIGHT_MEDIA_PARTLY_LINKED' | translate }} }
        @case ('shared_file') { {{ 'TRANS__IMPORT__PREFLIGHT_MEDIA_SHARED_FILE' | translate }} }
        @case ('shared') { {{ 'TRANS__IMPORT__PREFLIGHT_MEDIA_SHARED' | translate }} }
      }
      @if (!grouped) {: {{ w.value }}
        @for (file of w.shared; track $index) {
          <span class="admin-import-module__preflight-media-shared">
            @if (file.file_name === w.value) {
              — {{ 'TRANS__IMPORT__PREFLIGHT_MEDIA_OTHER_ROWS' | translate: {rows: file.rows.join(', ')} }}
            } @else {
              — {{ 'TRANS__IMPORT__PREFLIGHT_MEDIA_OVERVIEW_FILE_ROWS' | translate:
                   {file: file.file_name, rows: file.rows.join(', ')} }}
            }
            @if (file.rows_total > file.rows.length) {
              {{ 'TRANS__IMPORT__PREFLIGHT_MEDIA_OVERVIEW_FILE_ROWS_TOTAL' | translate: {total: file.rows_total} }}
            }
          </span>
        }
      }
    }
    @case ('id_collision') {
      @if (grouped) {
        {{ 'TRANS__IMPORT__PREFLIGHT_GROUP_ID_COLLISION' | translate }}
      } @else {
        {{ 'TRANS__IMPORT__PREFLIGHT_ID_COLLISION' | translate: {value: w.value} }}
      }
    }
    @case ('id_invalid') {
      @if (grouped) {
        {{ 'TRANS__IMPORT__PREFLIGHT_GROUP_ID_INVALID' | translate }}
      } @else {
        {{ 'TRANS__IMPORT__PREFLIGHT_ID_INVALID' | translate: {value: w.value} }}
      }
    }
    @case ('created_at') {
      @if (grouped) {
        {{ 'TRANS__IMPORT__PREFLIGHT_GROUP_CREATED_AT_INVALID' | translate }}
      } @else {
        {{ 'TRANS__IMPORT__PREFLIGHT_CREATED_AT_INVALID' | translate: {value: w.value} }}
      }
    }
    @case ('created_by') {
      {{ 'TRANS__IMPORT__PREFLIGHT_CREATED_BY_UNRESOLVED' | translate: {value: w.value} }}
    }
  }
</ng-template>

<!-- A field warning's reasons, each translated, comma-joined. -->
<ng-template #fieldReasons let-reasons>
  @for (reason of reasons; track $index) {<ng-container>{{ $first ? '' : ', ' }}{{ reason | translate }}</ng-container>}
</ng-template>
